import { render, staticRenderFns } from "./satellite-grid.vue?vue&type=template&id=0489520a&"
import script from "./satellite-grid.vue?vue&type=script&lang=js&"
export * from "./satellite-grid.vue?vue&type=script&lang=js&"
import style0 from "./satellite-grid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports